module.exports = __webpack_public_path__ + "img/20.b42ab76e.svg";